import { AuthLayout, TextLink } from '../components/ui';

/** Any address with nothing there; also what strangers get for private pages. */
export function NotFound() {
  return (
    <AuthLayout title="Page not found">
      <p className="text-ink">
        There’s nothing here. <TextLink to="/">Go to the home page</TextLink>.
      </p>
    </AuthLayout>
  );
}
